export default "__VITE_ASSET__f14b6d8b__"